import { render, staticRenderFns } from "./AiSummaryBox.vue?vue&type=template&id=d974271c&scoped=true"
import script from "./AiSummaryBox.vue?vue&type=script&lang=js"
export * from "./AiSummaryBox.vue?vue&type=script&lang=js"
import style0 from "./AiSummaryBox.vue?vue&type=style&index=0&id=d974271c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d974271c",
  null
  
)

export default component.exports